const meta = {
  auth: true,
  layout: "main",
  role: ["academy", "admin", "bi", "teacher", "hr", "call", "audit", "instructor", "tutor", "kurator", "examiner", "hunter"],
  permission: "head_access",
};

export default [
  {
    path: "/events",
    name: "events-management",
    component: () => import("../../modules/Events/pages/EventsList.vue"),
    meta,
  },
];
